import $ from 'jquery';
import Swal from 'sweetalert2';
import { getCookie } from '@/router/index.js';
import { get_domain_style } from '@/main';

export default {
  name: 'ResetView',
  data: () => ({
    form: {
      email: '',
    },
    errors: {},
    loading: false,
  }),
  computed: {
    styleConfig() {
      return get_domain_style();
    }
  },
  mounted() {
    this.csrfToken = getCookie("csrftoken");
  },

  methods: {
    validate_email(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },

    async submit_form() {
      const email = this.form.email.toLowerCase().trim();
      if (!email) {
        this.$notyf.error('Email is required');
        return;
      }


      if (!this.validate_email(email)) {
        this.$notyf.error('Invalid email');
        return;
      }
      const payload = {
        email: email,
      };
      this.loading = true;

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/forgot_password/';

      $.ajax({
        url: url,
        method: 'POST',
        crossDomain: true,
        xhrFields: { withCredentials: true },
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.csrfToken
        },
        data: JSON.stringify(payload),
        success: (response) => {
          const response_data = typeof response === 'string' ? JSON.parse(response) : response;
          if (response_data.status === 'success') {
            Swal.fire({
              title: 'Email Sent!',
              text: 'A password reset email has been sent to your email address.',
              icon: 'success',
            }).then(() => {
              this.$router.push('/');
            });
          } else {
            this.loading = false;
            Swal.fire({
              title: 'Error!',
              text: response_data.message,
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        },
        error: (xhr) => {
          this.loading = false;
          let errorMessage = 'Failed to send password reset email. Please try again.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    }
  }
}